import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import {JwksValidationHandler, OAuthService} from 'angular-oauth2-oidc-codeflow';
import {authConfig} from '../_services/authConfig';
import {AuthenticationService} from '../_services/authentication.service';
import {JwtHelperService} from '@auth0/angular-jwt';

import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';
import {environment} from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthGuard  extends KeycloakAuthGuard implements CanActivate {

    private AccessToken;
    private Jwthelper = new JwtHelperService();

    constructor(
        protected keycloakAngular: KeycloakService,
        protected router: Router,
        private oAuthService: OAuthService,
        private authenticationService: AuthenticationService
    ) {
      super(router, keycloakAngular);
    }

    isAccessAllowed(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
      return new Promise((resolve, reject) => {
        this.keycloakAngular.updateToken(10).then((isUpdated) => {
        });
        if (!this.authenticated) {
          this.keycloakAngular.login({
            idpHint: 'azure-ad',
            // scope: 'openid profile email role_list User.Read',
            scope: 'openid profile email roles',
            // redirectUri: environment.redirectUrl + window.location.pathname,
            redirectUri: environment.keycloakRedirectURL,
          })
            .catch(e => console.error(e));
          return reject(false);
        }

        const requiredRoles: string[] = route.data.roles;
        if (!requiredRoles || requiredRoles.length === 0) {
          return resolve(true);
        } else {
          if (!this.roles || this.roles.length === 0) {
            resolve(false);
          }
          resolve(requiredRoles.every(role => this.roles.indexOf(role) > -1));
        }
      });
    }
}
